import * as React from "react";
import { useCallback } from "react";
import AutoRefreshProvider from "views/components/contexts/AutoRefreshProvider";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectJobIds } from "views/logic/slices/searchExecutionSelectors";
import { executeActiveQuery } from "views/logic/slices/viewSlice";
const SearchPageAutoRefreshProvider = ({ children }) => {
  const dispatch = useViewsDispatch();
  const jobIds = useViewsSelector(selectJobIds);
  const onRefresh = useCallback(() => {
    if (!jobIds) {
      dispatch(executeActiveQuery());
    }
  }, [dispatch, jobIds]);
  return /* @__PURE__ */ React.createElement(AutoRefreshProvider, { onRefresh }, children);
};
export default SearchPageAutoRefreshProvider;
